export const heading = "Let's build your best retirement.";
export const body =
  "Your dedicated Retirable advisor is a U.S-based licensed fiduciary, specializing in holistic retirement planning. They're committed to always presenting your best solutions across retirement planning, enrollments, and other big decisions.";
